export const MULTIPLICATION = 'multiplication';
export const FRACTION = 'fraction';
export const MIXEDFRACTION = 'mixedFraction';
export const SQUAREROOT = 'squareRoot';
export const NTHROOT = 'nthRoot';
export const DIVIDE = 'divide';
export const ADDITION = 'addition';
export const SUBTRACTION = 'subtraction';
